// extracted by mini-css-extract-plugin
export default {"container":"InputError--container--a1d009","fullBorder":"InputError--fullBorder--e839c6"};